import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

interface SafetyNoticeProps {
  onAcknowledge: () => void;
}

const SafetyNotice: React.FC<SafetyNoticeProps> = ({ onAcknowledge }) => {
  const { t } = useLanguage();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-3xl max-w-md w-full p-6 text-left">
        <div className="flex items-center gap-2 mb-3">
          <svg className="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 9v2m0 4h.01M5.07 19h13.86a2 2 0 001.74-3L13.74 4a2 2 0 00-3.48 0L3.34 16a2 2 0 001.73 3z" />
          </svg>
          <h2 className="text-xl font-bold">{t('protocols.safetyTitle')}</h2>
        </div>
        <p className="text-stone-700 mb-6">{t('protocols.safetyNotice')}</p>
        <button
          onClick={onAcknowledge}
          className="w-full px-6 py-3 text-base font-medium text-white bg-accent rounded-full hover:bg-accent-dark"
        >
          {t('protocols.understand')}
        </button>
      </div>
    </div>
  );
};

export default SafetyNotice;
